import React from 'react';
import classNames from 'classnames';
import styles from './prenav.scss';

import { TopLinks } from '../../link-list/TopLinks';

export const Prenav = ({
  isFocused = false,
  isStickyHeaderActive = false,
  onFocus = null,
  topLinksData = [],
}) => {
  return (
    <div
      className={classNames(styles.topBar, {
        [styles.topBar__collapsed]: isFocused || isStickyHeaderActive,
      })}
      data-testid="header-top-bar"
      onFocus={onFocus}
    >
      <div
        className={classNames(styles.topLinks)}
        data-testid="header-top-links"
      >
        <span className={styles.nkuContainer}>
          <a
            href="/content/never-knowingly-undersold"
            className={styles.nkuLink}
          >
            NEVER KNOWINGLY UNDERSOLD
          </a>
        </span>
        <TopLinks links={topLinksData} />
      </div>
    </div>
  );
};
